export const domestic = [
  "img/used/clients/domestic/1.png",
  "img/used/clients/domestic/2.png",
  "img/used/clients/domestic/3.png",
  "img/used/clients/domestic/4.jpg",
  "img/used/clients/domestic/5.jpg",
  "img/used/clients/domestic/6.jpg",
  "img/used/clients/domestic/7.jpg",
  "img/used/clients/domestic/8.jpg",
];

export const others = [
  "img/used/clients/1.jpg",
  "img/used/clients/2.jpg",
  "img/used/clients/3.png",
  "img/used/clients/4.png",
  "img/used/clients/5.gif",
  "img/used/clients/6.png",
  "img/used/clients/7.png",
  "img/used/clients/8.png",
  "img/used/clients/9.png",
  "img/used/clients/10.png",
  "img/used/clients/11.jpg",
  "img/used/clients/12.jpg",
  "img/used/clients/13.png",
  "img/used/clients/14.png",
  "img/used/clients/15.png",
  "img/used/clients/16.png",
  "img/used/clients/17.png",
  "img/used/clients/18.png",
  "img/used/clients/19.png",
  "img/used/clients/20.png",
  "img/used/clients/21.png",
  "img/used/clients/22.png",
  "img/used/clients/23.png",
  "img/used/clients/24.png",
  "img/used/clients/25.jpg",
];
